module.exports = __webpack_public_path__ + "static/media/caret.db435222.svg";